<form [formGroup]="yearVinForm">
  <div class="row">
    <div class="row column twelve lg-push-two md-eight md-push-two">
      <h2
        dsContent
        [contentPath]="'policy.replaceVehicleVinYearHeader'"
        class="font-weight-bold"
      ></h2>
    </div>

    <div class="row column twelve lg-push-two md-eight md-push-two">
      <year-vin
        [vinYearForm]="yearVinForm"
        [years]="years$ | async"
        [sameVINErrorMessage]="sameVINErrorMessage"
        [isSameVin]="isSameVin"
        [errorMessage]="errorMessage"
        (checkVinEvent)="verifyVin($event)"
        [yearLabel]="'Year'"
      ></year-vin>
    </div>

    <div class="pad-top-5 row column twelve lg-push-two md-eight md-push-two pad-bottom-20">
      <a href="#" data-cy="yearVinFindMyVin" (click)="findVIN($event)">{{
        vinContent?.linkText
      }}</a>
    </div>

    @if (showMsrp$ | async) {
      @if (enabledMsrp) {
        <div class="row column twelve lg-push-two md-eight md-push-two">
          <amfam-msrp
            [parentForm]="yearVinForm"
            (vehicleDetailsLoaded)="onVehicleDetailsLoaded($event)"
          ></amfam-msrp>
        </div>
      }
    }

    <div class="pad-top-20 row column twelve lg-push-two md-eight md-push-two">
      <call-to-action
        [displayBackButton]="true"
        [tertiaryButtonName]="'Cancel'"
        [disabled]="
          !vehicleDetails ||
          !(roleService.isAuthorized('addvehicle_walkthrough') | async) ||
          yearVinForm.invalid
        "
        [primaryButtonName]="'Continue'"
        (primaryEvent)="submit()"
        (tertiaryEvent)="exitEvent()"
        (backEvent)="goBackOneStep()"
      ></call-to-action>
    </div>
  </div>
</form>
<ds-grace-period
  *dsPartnerAFI
  [(visible)]="displayPolicyGracePeriod"
  [activeAgents]="activeAgents$ | async"
  [user]="userState$ | async"
  [isAdvancedCustomer]="(getAdvanceAutoPolicies$ | async)?.length > 0"
></ds-grace-period>

<amfam-find-vin-modal [vinContent]="vinContent" [findVinFlowModalId]="findVinFlowModalId">
</amfam-find-vin-modal>

<amfam-early-exit-modal
  [exitFlowConfimationText]="exitFlowConfimationText"
  [exitPrimaryButtonText]="exitPrimaryButtonText"
  [earlyExitFlowModalId]="exitFlowModalId"
  (stay)="stayFromExitModal()"
  (leavePage)="navigateToOverview()"
></amfam-early-exit-modal>
